import { render } from "./HomeExamPaper.vue?vue&type=template&id=69739d59&scoped=true"
import script from "./HomeExamPaper.vue?vue&type=script&lang=js"
export * from "./HomeExamPaper.vue?vue&type=script&lang=js"

import "./HomeExamPaper.vue?vue&type=style&index=0&id=69739d59&lang=less&scoped=true"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69739d59"]])

export default __exports__